import React from "react";
import "./ACMarksSidePanel.css";
import { getCenterType, checkunitIsConsortiaUnit } from "../../utils/utils";
import { useUnits } from "../../context/UnitsContext";
import { useCenter } from "../../context/CenterContext";
import { useConsortiaCenter } from "../../context/ConsortiaCenterContext";
import { useLocation } from "react-router-dom";
import {useSubject} from "../../context/SubjectContext";

const ACMarksSidePanel = ({
  assessmentCandidateData = [],
  candidatePayloadData,
  setSelectedCandidate,
  selectedCandidate,
  candidateDataMap,
  mode, 
}) => {
  let candidates = (assessmentCandidateData || []).map((val) => {
    return {
      candidateName: val.candidateName,
      candidateId: val.centreCandidateNumber || val.candidateNumber,
      centreNumber: val.centreNumber,
    };
  });

  const onClickCandidate = (candidate, event) => {
    const link = event.currentTarget.querySelector("a");
    link.focus();

    // Then remove focus after 1 second
    setTimeout(() => {
      link.blur();
    }, 1000);
    setSelectedCandidate(candidate.candidateId);
  };
      const { consortiaUnits = [] } = useUnits();
    const location = useLocation();
    const { unit, sessionId } = location.state || {};
      const { centerNumber } = useCenter();
      const {subjectData} = useSubject();
      const {consortiaCentres = []} = useConsortiaCenter();
    
      const currentCentreType = getCenterType(consortiaCentres, Number(centerNumber), subjectData?.selectedSubject, subjectData?.selectedSubjectId) || '';
      const unitcode = unit.split(" ")[0];
      const consortiaUnitcode =
      String(unit ?? "")
        .toUpperCase()
        .match(/^[A-Z0-9]+/)?.[0] || "";
    const isConsortiaUnit = checkunitIsConsortiaUnit(
        consortiaCentres,
        centerNumber,
        sessionId,
        consortiaUnitcode,
      );
  
  return (
    <aside className="candidate-menu xis-hidden">
      <div
        id="pnlSideMenuNav"
        style={{
          overflow: "auto",
          height: "calc(100% - 77px)",
          paddingBottom: "4em",
        }}
      >
        <table
          className="table is-hoverable is-fullwidth"
          id="tblUnitListTable"
        >
          <thead>
            <tr>
              <th>Sample candidates</th>
            </tr>
          </thead>
          <tbody>
            {candidates.map((candidate) => {
              let currentCandidate = candidatePayloadData.find(
                (val) => val.centreCandidateNumber == candidate.candidateId
              );
              let isAllCriteriaFilled =
                currentCandidate && Array.isArray(currentCandidate.criteria)
                  ? currentCandidate.criteria.every(
                      (item) => item.achieved && item.achieved.trim() !== ""
                    )
                  : false;

              const { achievedCount, candidateMarks } =
                candidateDataMap[candidate.candidateId] || {};
              return (
                <tr
                  key={candidate.candidateId}
                  onClick={(e) => onClickCandidate(candidate, e)}
                >
                  <td className="candidate-cell">
                    <a
                      tabIndex={0}
                      className={`candidate-list-item ${
                        selectedCandidate === candidate.candidateId
                          ? "is-active"
                          : ""
                      }`}
                    >
                      <span className="candidate-status">
                        <span
                          className="icon"
                          title="You have entered marks for this candidate"
                        >
                          {mode === "view" ||
                          (achievedCount == candidateMarks &&
                            isAllCriteriaFilled) ? (
                            <span
                              className="icon"
                              title="You have entered marks for this candidate"
                              id="candidateStatusIcon_1"
                            >
                              <svg
                                aria-hidden="true"
                                focusable="false"
                                style={{ fill: "#2B8000" }}
                                viewBox="0 0 24 24"
                              >
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0z"></path>
                              </svg>
                            </span>
                          ) : (
                            <span
                              className="icon"
                              title="You have entered marks for this candidate"
                            >
                              <svg
                                style={{ fill: "#f14668" }}
                                focusable="false"
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M4.00137 20.0099C2.46137 20.0099 1.50137 18.3399 2.27137 17.0099L9.80137 3.99994C10.5714 2.66994 12.4914 2.66994 13.2614 3.99994L20.7914 17.0099C21.5614 18.3399 20.6014 20.0099 19.0614 20.0099H4.00137ZM19.0614 18.0099L11.5314 4.99994L4.00137 18.0099H19.0614Z"
                                ></path>
                                <path d="M10.5312 10.01V13C10.5312 13.55 10.9812 14 11.5312 14C12.0812 14 12.5312 13.55 12.5312 13V10.01C12.5312 9.46001 12.0812 9.01001 11.5312 9.01001C10.9812 9.01001 10.5312 9.46001 10.5312 10.01Z"></path>
                                <circle cx="11.5312" cy="16.01" r="1"></circle>
                              </svg>
                            </span>
                          )}
                        </span>
                      </span>
                      <div className="candidate-info">
                        {((currentCentreType === "Lead" && isConsortiaUnit) || (currentCentreType === 'Rest' && mode ==='view' && isConsortiaUnit) )&& <span  style={{fontSize:"13px", fontWeight:"500", }}> CENTRE:{candidate.centreNumber}</span>}
                        <span className="candidate-name">
                          {candidate.candidateName}
                        </span>
                        <span className="candidate-number">
                          {candidate.candidateId}
                        </span>
                      </div>
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </aside>
  );
};

export default ACMarksSidePanel;
